import { Helmet } from "react-helmet";
import {
    Box,
    Container,
    Grid,
    Button,
    Select,
    MenuItem,
    MenuList,
    Divider,
    Paper,
    usePagination,
    TextField,
    InputAdornment,
    ClickAwayListener,
    Collapse,
    Checkbox,
    Autocomplete,
    Typography,
    Stack,
    Popper,
    FormGroup,
    FormControlLabel,
    Grow,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useMemo, useCallback } from "react";
import { useDispatch } from "react-redux";
import Upload from "./UploadFiles";
import { ReactComponent as ChevronExpandDown } from "../../../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../../../assets/icons/chevron-expand-up.svg";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";
import { ReactComponent as Download } from "../../../../assets/icons/download.svg";
import { ReactComponent as Eye } from "../../../../assets/images/eye.svg";
import { ReactComponent as FilterStatus } from "../../../../assets/icons/filter-status.svg";
import MessageDialog from "../../../../components/MessageDialog";
import importFilesService from "../../../../services/importFiles.service";
import * as Util from "../../../../services/global.service";
import DialogDownloadTemplate from "../../../../components/kpi/DialogDownloadTemplate";
import DialogDetail from "../../../../components/kpi/DialogDetailImport";
import ConfirmDialog from "../../../../components/ConfirmDialogImport";
import cssVariables from "../../../../theme/cssVariables";
import { styled } from "@mui/styles";
import { useFormik } from 'formik';
import * as yup from 'yup';
import { ReactComponent as ErrorIcon } from "../../../../assets/images/circle-fill-error.svg";
import { ReactComponent as ArrowIcon } from "../../../../assets/images/arrowDownMyFeedback.svg";

function CustomPagination(props) {
    const { t } = useTranslation();
    const useStyles = makeStyles({
        paginationRoot: {
            color: `${cssVariables.color.primary}`,
            backgroundColor: "white!important",
            minWidth: "30px!important",
            padding: "5px!important",
        },
        paginationSelected: {
            color: "white!important",
            border: "1px solid rgba(93, 161, 150, 0.5)!important",
            backgroundColor: `${cssVariables.color.primary}!important`,
            minWidth: "30px!important",
            padding: "5px!important",
        },

    });
    const classes = useStyles();
    const List = styled("ul")({
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
    });
    const { items } = usePagination({
        count: props.count,
        showFirstButton: true,
        showLastButton: true,
    });
    return (
        <nav>
            <List>
                {items.length > 0 ? (
                    items.map(({ page, type, selected, ...item }, index) => {
                        let children = null;
                        selected = type === "page" && page === props.selected ? props.selected : selected
                        if (type === "start-ellipsis" || type === "end-ellipsis") {
                            children = "…";
                        } else if (type === "page") {
                            children = (
                                <Button
                                    {...item}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {page}
                                </Button>
                            );
                        } else if (type === "first" || type === "last") {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    style={{
                                        fontWeight: selected ? "bold" : undefined,
                                    }}
                                    variant="outlined"
                                    classes={{
                                        root: selected
                                            ? classes.paginationSelected
                                            : classes.paginationRoot,
                                    }}
                                    sx={{ margin: "0 5px" }}
                                >
                                    {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                                </Button>
                            );
                        } else {
                            children = (
                                <Button
                                    {...item}
                                    disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                                    size="small"
                                    type="button"
                                    variant="outlined"
                                    classes={{
                                        root: classes.paginationRoot,
                                    }}
                                >
                                    {type === "previous"
                                        ? `${t('label.previous')}`
                                        : type === "next"
                                            ? `${t('label.next')}`
                                            : ""}
                                </Button>
                            );
                        }
                        return <li key={index}>{children}</li>;
                    })

                ) : (
                    <></>
                )}
                {props.setCurrentPage(items)}
            </List>
        </nav>
    );
}

const useStyles = makeStyles({
    flexPaper: {
        flex: 1,
        minWidth: 350,
        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
        borderRadius: "10px !important        "
    },
    root: {
        display: 'flex',
        width: "100%",
        flexWrap: 'wrap',
        marginTop: "30px"
    },
    select: {
        '& div ': {
            padding: "8.5px 8.5px 8.5px 15px"
        },
    },
    selectError: {
        background: "#CC6058",
        '& div ': {
            padding: "8.5px 8.5px 8.5px 15px"
        },
        '& fieldset': {
            "border-color": "#CC6058"
        },
    },
    selectDisabled: {
        // '& .MuiFormControl-root': {
        background: "#FAFAFA",
        borderRadius: "4px",
        // },
        '&.Mui-selected': {
            '-webkit-text-fill-color': '#404349 !important',
            backgroundColor: "#FAFAFA !important"
        },
        '& .Mui-disabled': {
            '-webkit-text-fill-color': '#404349 !important',
            backgroundColor: "#FAFAFA !important"
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: "none"
        },
        '& div ': {
            padding: "8.5px 8.5px 8.5px 15px"
        }
    },
    inputError: {
        '& div > input': {
            color: "#CC6058",
            background: "#CC60581A",
            textAlign: "center",
            height: '6px',
            border: "1px solid #CC6058 !important",
            borderRadius: "4px"
        }
    },
    disabled: {
        '& div > input': {
            height: '8px',
            position: "relative"
        },
        '& .Mui-disabled': {
            '-webkit-text-fill-color': '#404349 !important',
            backgroundColor: "#FAFAFA"
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: "none"
        }
    },
    expandableIcon: {
        // padding: 3,
        width: '20px',
        height: '20px',
        borderRadius: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: '.3s',
        // transform: "rotate(90deg)",
        '&.active': {
            transform: "rotate(-180deg)",
        }
    },
    arrowSvg: {
        "& > path": {
            fill: "#567DF4",
            // stroke: "#567DF4",
        },
    },
});
const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const Import = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [checkResired, setCheckRsquired] = React.useState({});
    const [reSet, setreSet] = React.useState(false);
    const [items, setItems] = React.useState([]);
    const [mainItems, setMainItems] = React.useState([]);
    const [dataTemplateType, setDataTemplateType] = React.useState([]);
    const [dataCycle, setDataCycle] = React.useState([]);
    const [dataSchedules, setDataSchedules] = React.useState([]);
    const [typeFiles, setTypeFiles] = React.useState([]);
    const [dataDetail, setDataDetail] = React.useState([]);
    const [require, setRequire] = React.useState(false);
    const [startAgain, setStartAgain] = React.useState(false);
    const [dataFiles, setDataFiles] = React.useState([]);
    const [importLog, setImportLog] = React.useState('');
    const [fileName, setFileName] = React.useState('');
    const [templateTypeName, setTemplateTypeName] = React.useState('');
    const [cycleName, setCycleName] = React.useState('');
    const [totalRow, setTotalRow] = React.useState(0);
    const [openDownloadTemplate, setOpenDownloadTemplate] = React.useState(false);
    const [openDetail, setOpenDetail] = React.useState(false);
    const [itemsProgress, setItemsProgress] = React.useState([]);
    const [mainItemsProgress, setMainItemsProgress] = React.useState([]);
    const [perPage, setPerPage] = React.useState(10);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalPage, setTotalPage] = React.useState(1);
    const [result, setResult] = React.useState("");
    const [sortBy, setSortBy] = React.useState("");
    const [sort, setSort] = React.useState("");
    const anchorRef = React.useRef(null);
    const [active, setActive] = React.useState(true);
    const [notActive, setNotActive] = React.useState(false);
    const [wait, setWait] = React.useState(true);
    const [process, setProcess] = React.useState(true);
    const [fail, setFail] = React.useState(true);
    const [completed, setCompleted] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const [status, setStatus] = React.useState(["Wait", "In Progress", "Completed", "Fail"]);
    const [checkstatus, setCheckStatus] = React.useState({});
    const [statusDetail, setStatusDetail] = React.useState("");
    const [isCollapse, setCollapse] = React.useState(false);

    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const validationSchema = yup.object({
        templateType: yup.string().required(t('admin.inputForm.msgError.nameTH')),
        // cycle: yup.string().required(t('admin.inputForm.msgError.nameTH')),
    });
    const formik = useFormik({
        initialValues: {
            templateType: "",
            cycle: "",
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
        },
    });

    useEffect(() => {
        importFilesService.getTemplateType().then((rs) => {
            setDataTemplateType(Util.formatData(rs?.data?.templates, []));
            setDataCycle(Util.formatData(rs?.data?.cycles, []));
            setDataSchedules(Util.formatData(rs?.data?.schedules, []));
            setTypeFiles(Util.formatData(rs?.data?.configuration.file.extension, []))
        }).catch((err) => {

        })
        getList()
    }, []);
    const getList = () => {
        importFilesService.getList(perPage, currentPage, result, sortBy, sort).then((rs) => {
            setMainItemsProgress(rs.data.log)
            setItemsProgress(rs.data.log)
            setTotalPage(rs.data.total_page)
            setStartAgain(false)
        }).catch((err) => {

        })
    }

    let setValFilter = (field, require_cycle, data) => {
        if (field === "templateType") {
            formik.setFieldValue("templateType", data)
            setRequire(require_cycle)
        } else {
            formik.setFieldValue(field, data)
        }
    }

    let sortData = (key, sort) => {
        setSortBy(key)
        setSort(sort)
        // getList()
        importFilesService.getList(perPage, currentPage, result, key, sort).then((rs) => {
            setMainItemsProgress(rs.data.log)
            setItemsProgress(rs.data.log)
            setTotalPage(rs.data.total_page)
            setStartAgain(false)
        }).catch((err) => {

        })
    }

    const openNewTab = (val) => {
        const newWindow = window.open(val, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    let getDataFilter = () => {
        let datas = new FormData();
        if (dataFiles.length > 0) {
            for (let index = 0; index <= dataFiles.length - 1; index++) {
                setFileName(dataFiles[index].name);
                datas.append("file", dataFiles[index]);
                datas.append("template", formik.values.templateType);
                datas.append("cycle", formik.values.cycle);
            }
        } else {
            datas.append("file", "");
        }
        importFilesService.uploadFiles(datas).then((rs) => {
            setImportLog(rs?.data?.import_log)
            setTemplateTypeName(rs?.data?.tempate)
            setCycleName(rs?.data?.cycle)
            setTotalRow(rs?.data?.total)
            if (rs?.data.status === "success") {
                setConfirmSendDialog(true)
            } else if (rs?.data.status === "fail") {
                handleOpenFailedMessageDialog(true)
            }

        }).catch((err) => {

        })
    }
    const uploadFileSuccess = (dataFile) => {
        setDataFiles(dataFile)
    }
    const onOpenDownloadTemplate = () => {
        setOpenDownloadTemplate(true)
    }
    const onCloseDownloadTemplate = () => {
        setOpenDownloadTemplate(false)
    }
    const onOpenDetail = (data, status) => {
        setOpenDetail(true)
        setDataDetail(data)
        setStatusDetail(status)
    }
    const onCloseDetail = () => {
        setOpenDetail(false)
    }
    const [confirmSendDialog, setConfirmSendDialog] = React.useState(false);
    const handleConfirmSendDialog = (value) => {
        setConfirmSendDialog(value)
    };

    const handleSendConfirm = () => {
        importFilesService.startProcess({
            "import_log": importLog,
            "action": "start"
        }).then((rs) => {
            setConfirmSendDialog(false)
            getList()
        }).catch((err) => {

        })
    };
    const handleCancelConfirm = () => {
        importFilesService.startProcess({
            "import_log": importLog,
            "action": "cancel"
        }).then((rs) => {
            setConfirmSendDialog(false)
            getList()
        }).catch((err) => {

        })
    };
    const handleStartAgain = (id, name, tempate, cycle, total) => {
        setImportLog(id)
        setFileName(name)
        setTemplateTypeName(tempate)
        setCycleName(cycle)
        setTotalRow(total)
        setStartAgain(true)
        setConfirmSendDialog(true)
    };
    const handleGoToResult = () => {
        openNewTab(`/admin/import/${importLog}`)
        setFailedMessageDialog(false)
    }
    let checkIndeterminateStatus = () => {
        let check = true
        let data = checkstatus
        let getObjectKey = Object.keys(data)
        let checksTrue = getObjectKey.filter((rs) => data[rs] === true)
        let checksFalse = getObjectKey.filter((rs) => data[rs] === false)
        if (getObjectKey.length !== checksTrue.length && getObjectKey.length !== checksFalse.length) {
            check = true
        } else {
            check = false
        }
        return check;
    }
    useEffect(() => {
        let sumData = {}
        for (let index = 0; index <= status.length - 1; index++) {
            sumData[status[index]] = true
        }
        setCheckStatus(sumData)
    }, [status])
    const changeStatus = (statusSelect) => {
        let data = JSON.parse(JSON.stringify(checkstatus))
        let name = ""
        let sumData = {}
        if (statusSelect === "all") {
            let getObjectKey = Object.keys(data)
            let check = getObjectKey.filter((rs) => data[rs] === true)
            if (check.length !== status.length) {
                for (let index = 0; index <= status.length - 1; index++) {
                    sumData[status[index]] = true
                    if (sumData[status[index]] === true) {
                        if (status[index] === "Wait") {
                            name += name === "" ? "wait" : ",wait"
                        } else if (status[index] === "In Progress") {
                            name += name === "" ? "process" : ",process"
                        } else if (status[index] === "Completed") {
                            name += name === "" ? "complete" : ",complete"
                        } else if (status[index] === "Fail") {
                            name += name === "" ? "fail" : ",fail"
                        }
                    }
                }
            } else {
                for (let index = 0; index <= status.length - 1; index++) {
                    sumData[status[index]] = false
                }
            }
            setCheckStatus(sumData)
        } else {
            data[statusSelect] = !checkstatus[statusSelect]
            for (let index = 0; index <= status.length - 1; index++) {
                if (data[status[index]] === true) {
                    if (status[index] === "Wait") {
                        name += name === "" ? "wait" : ",wait"
                    } else if (status[index] === "In Progress") {
                        name += name === "" ? "process" : ",process"
                    } else if (status[index] === "Completed") {
                        name += name === "" ? "complete" : ",complete"
                    } else if (status[index] === "Fail") {
                        name += name === "" ? "fail" : ",fail"
                    }
                }
            }
            setCheckStatus(data)
        }
        setResult(name)
        importFilesService.getList(perPage, currentPage, name !== "" ? name : "-", sortBy, sort).then((rs) => {
            setMainItemsProgress(rs.data.log)
            setItemsProgress(rs.data.log)
            setTotalPage(rs.data.total_page)
            setStartAgain(false)
        }).catch((err) => {

        })
    };
    let checkAllStatus = () => {
        let check = true
        let data = checkstatus
        let getObjectKey = Object.keys(data)
        let checks = getObjectKey.filter((rs) => data[rs] === true)
        if (checks.length !== status.length) {
            check = false
        } else {
            check = true
        }
        return check;
    }
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };
    // const currentData = useMemo(() => {
    //     const firstPageIndex = (currentPage - 1) * perPage;
    //     const lastPageIndex = firstPageIndex + perPage;
    //     return mainItemsProgress
    //         .slice(firstPageIndex, lastPageIndex);
    // }, [mainItemsProgress, currentPage, perPage]);
    const handleTotalPage = () => {
        const List = mainItemsProgress
        const totalPage =
            Math.ceil(List.length / perPage) === 0
                ? 1
                : Math.ceil(List.length / perPage);
        setTotalPage(totalPage);
    };
    useEffect(() => {
        handleTotalPage();
    }, [mainItemsProgress, perPage]);
    // useEffect(() => {
    //     let update = checkResired
    //     if (Object.keys(checkResired)[0] !== undefined) {
    //         if (update[Object.keys(checkResired)[0]] === false) {
    //             currentData.sort(function (b, a) {
    //                 if (a[Object.keys(checkResired)[0]] > b[Object.keys(checkResired)[0]]) {
    //                     return -1;
    //                 }
    //                 if (b[Object.keys(checkResired)[0]] > a[Object.keys(checkResired)[0]]) {
    //                     return 1;
    //                 }
    //                 return 0;
    //             });
    //             setreSet(!reSet)
    //         } else if (update[Object.keys(checkResired)[0]] === true) {
    //             currentData.sort(function (a, b) {
    //                 if (a[Object.keys(checkResired)[0]] > b[Object.keys(checkResired)[0]]) {
    //                     return -1;
    //                 }
    //                 if (b[Object.keys(checkResired)[0]] > a[Object.keys(checkResired)[0]]) {
    //                     return 1;
    //                 }
    //                 return 0;
    //             });
    //             setreSet(!reSet)
    //         }
    //     }
    // }, [currentData]);
    const handlePerPageChange = (event) => {
        setPerPage(event.target.value);
        importFilesService.getList(event.target.value, currentPage, result, sortBy, sort).then((rs) => {
            setMainItemsProgress(rs.data.log)
            setItemsProgress(rs.data.log)
            setTotalPage(rs.data.total_page)
            setStartAgain(false)
        }).catch((err) => {

        })
    };
    const handleSetCurrentPage = (value) => {
        const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
        if (getSelectedPage.length > 0) {
            setCurrentPage(getSelectedPage[0].page)
        }
    };
    const handleSetCurrentPageData = () => {
        getList()
    };
    useEffect(() => {
        handleSetCurrentPageData()
    }, [currentPage]);
    const handleCollapse = () => {
        setCollapse(!isCollapse)
    }
    return (
        <Box style={{ maxHeight: "100%", overflowY: "auto" }}>
            <Helmet>
                <title>Import | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A">
                            <span style={styles.end} >
                                Import
                            </span>
                        </Typography>
                    </Grid>
                    <Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} >
                            <Typography variant="h2" color="#404349" fontSize={36} lineHeight="40px" >
                                Import
                            </Typography>
                            <Box sx={{ display: "flex" }}>
                                {/* <Button onClick={e => console.log("View History")} sx={{ display: "flex", height: "45px", textTransform: "none" }} variant="dashed-solid" >
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <HistoryLF /><Typography ml="8px" fontSize={18} lineHeight="26.91px" fontWeight="500" color="#404349">View History</Typography>
                                    </Box>
                                </Button> */}
                                <Button onClick={e => onOpenDownloadTemplate()} sx={{ display: "flex", height: "45px", textTransform: "none", marginLeft: "20px" }} variant="dashed-solid" >
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <Download /><Typography ml="8px" fontSize={18} lineHeight="26.91px" fontWeight="500" color="#404349">Download Template</Typography>
                                    </Box>
                                </Button>
                            </Box>
                        </Box>
                        {Util.formatData(dataSchedules, []).length > 0 ?
                            <Box sx={{ background: "rgba(86, 125, 244, 0.1)", border: "1px solid #567DF4", borderRadius: "5px", padding: "20px" }} mt="30px">
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <ErrorIcon></ErrorIcon>
                                        <Typography fontSize={18} lineHeight="19.8px" color="#567DF4" pl="10px">
                                            {"Integrating Master Data from IPOP Core"}
                                        </Typography>
                                    </Box>
                                    <div className={`clickable ${classes.expandableIcon} ${isCollapse ? 'active' : ''}`} onClick={handleCollapse} id="prevent"><ArrowIcon className={classes.arrowSvg} sx={{ fontSize: "20px" }} id="prevent" /></div>
                                </Box>
                                <Collapse in={isCollapse}>
                                    <Box mt="10px" sx={{ ".MuiTypography-root": { "&:before": { content: '""', width: "5px", height: "5px", background: "#567DF4", "border-radius": "50%", "margin-bottom": "4px", "margin-right": "10px", "margin-left": "3  5px", display: "inline-block", } } }}>
                                        {dataSchedules.map((item, index) => (
                                            <Typography fontSize={18} lineHeight="26.91px" color="#567DF4" pl="10px">
                                                {item?.name + " " + "at" + " " + item?.time}
                                            </Typography>
                                        ))}
                                    </Box>

                                </Collapse>
                            </Box>
                            : null
                        }
                        <Box sx={{ background: "#FFFFFF", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)", borderRadius: "10px", }} p="20px 40px 25px" mt="30px">
                            <Typography variant="h2" color="#404349" fontSize={24} lineHeight="26.4px" ml="-15px" mb="30px">
                                Validate File
                            </Typography>
                            <Box sx={{ margin: "0 -50px", display: "flex", flexFlow: "row wrap" }}>
                                <Box pb="20px" sx={{ width: "calc(50% - 80px)", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" }, margin: "0 40px" }}>
                                    <Typography mb="7px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Template Type <span style={{ color: "#CC6058" }}>*</span></Typography>
                                    <Select
                                        variant="outlined"
                                        defaultValue=""
                                        displayEmpty
                                        size="small"
                                        fullWidth
                                        className="white-bg"
                                        value={formik.values.templateType}
                                        classes={{ root: classes.select }}
                                        MenuProps={{ autoFocus: false }}
                                        inputProps={{
                                            sx: {
                                                "&::placeholder": {
                                                    color: "#AAAAAA",
                                                    fontWeight: "300",
                                                    opacity: "1"
                                                }
                                            }
                                        }}
                                    >
                                        <MenuItem disabled value="" sx={{ display: "none" }}>
                                            <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>Select template type</Typography>
                                        </MenuItem>
                                        {Util.formatData(dataTemplateType, []).length > 0 ?
                                            dataTemplateType.map((item, idx) => {
                                                return (
                                                    <MenuItem value={item.id} key={idx} onClick={e => setValFilter("templateType", item?.require_cycle, item?.id)}>
                                                        <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{item?.name}</span>
                                                    </MenuItem>
                                                )
                                            })
                                            :
                                            <MenuItem value="">
                                                <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>---{t('label.noData')}---</Typography>
                                            </MenuItem>
                                        }
                                    </Select>
                                </Box>
                                <Box pb="20px" sx={{ width: "calc(50% - 80px)", ".MuiFormControl-root": { marginTop: "7px" }, ".Mui-disabled": { "& fieldset": { borderColor: "#CED4DA" }, background: "#F3F3F3", WebkitTextFillColor: "#AAAAAA !important" }, margin: "0 40px" }}>
                                    <Typography mb="7px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Cycle <span style={{ color: "#CC6058" }}>*</span></Typography>
                                    <Select
                                        variant="outlined"
                                        defaultValue=""
                                        displayEmpty
                                        size="small"
                                        fullWidth
                                        className="white-bg"
                                        value={formik.values.cycle}
                                        disabled={require === true ? false : true}
                                        classes={{ root: require === true ? classes.select : classes.selectDisabled }}
                                        MenuProps={{ autoFocus: false }}
                                        inputProps={{
                                            sx: {
                                                "&::placeholder": {
                                                    color: "#AAAAAA",
                                                    fontWeight: "300",
                                                    opacity: "1"
                                                }
                                            }
                                        }}
                                    >
                                        <MenuItem disabled value="" sx={{ display: "none" }}>
                                            <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>Select cycle</Typography>
                                        </MenuItem>
                                        {Util.formatData(dataCycle, []).length > 0 ?
                                            dataCycle.map((item, idx) => {
                                                return (
                                                    <MenuItem value={item.id} key={idx} onClick={e => setValFilter("cycle", true, item.id)}>
                                                        <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>{item?.name}</span>
                                                    </MenuItem>
                                                )
                                            })
                                            :
                                            <MenuItem value="">
                                                <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>---{t('label.noData')}---</Typography>
                                            </MenuItem>
                                        }
                                    </Select>
                                </Box>
                                <Box sx={{ width: "calc(50% - 80px)" }}>
                                    <Upload sendFiles={uploadFileSuccess} typeFiles={typeFiles}></Upload>
                                </Box>
                            </Box>
                            <Box sx={{ justifyContent: "flex-end", display: "flex", paddingTop: "10px" }}>
                                <Box sx={{ display: "flex", }}>
                                    {/* <Button color="primary" variant="contained" fullWidth disabled={formik.values.templateType !== "" && require ? formik.values.cycle !== "" : formik.values.cycle === "" && dataFiles.length > 0 ? false : true} onClick={getDataFilter}> */}
                                    <Button color="primary" variant="contained" fullWidth disabled={formik.values.templateType !== "" && require ? formik.values.cycle !== "" && dataFiles.length > 0 ? false : true : formik.values.templateType !== "" && require === false ? dataFiles.length > 0 ? false : true : true} onClick={getDataFilter}>
                                        <Typography sx={{ textTransform: "none" }} fontSize={16} lineHeight="29px" fontWeight="500" color="#FFF">Validate</Typography>
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} pt="30px">
                            <Typography variant="h2" color="#404349" fontSize={30} lineHeight="45px" >
                                History
                            </Typography>
                        </Box>
                        <div className={classes.root}>
                            <Paper className={classes.flexPaper} >
                                <Box
                                    px="40px"
                                >
                                    <Box
                                        px="25px"
                                        py="19px"
                                        sx={{ display: "flex", flexDirection: "row" }}
                                    >
                                        <Box sx={{ display: "flex", flexDirection: "row", width: "calc(36.92% - 36px)" }} pr="15px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                Name
                                            </Typography>
                                            <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", "asc")} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", "desc")} />
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", flexDirection: "row", width: "calc(18.9% - 36px)" }} pr="15px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                Success / Total
                                            </Typography>
                                            <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("total", "asc")} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("total", "desc")} />
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", flexDirection: "row", width: "calc(10.64% - 36px)" }} pr="15px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                Fail
                                            </Typography>
                                            <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("fail", "asc")} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("fail", "desc")} />
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", flexDirection: "row", width: "calc(18.9% - 36px)" }} pr="15px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                                {/* {t('admin.label.createdBy')} */}
                                                Uploaded By
                                            </Typography>
                                            <Typography component="span" style={{ flexDirection: "column", justifyContent: "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("updated_by", "asc")} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("updated_by", "desc")} />
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", flexDirection: "row", width: "calc(14.66% - 36px)", justifyContent: "center" }} pr="15px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px", }}>
                                                {/* {t('admin.label.createdBy')} */}
                                                Result
                                            </Typography>
                                            <Stack direction="row" spacing={2}>
                                                <div>
                                                    <FilterStatus
                                                        ref={anchorRef}
                                                        id="composition-button"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={handleToggle}
                                                    />
                                                    <Popper
                                                        open={open}
                                                        anchorEl={anchorRef.current}
                                                        role={undefined}
                                                        placement="bottom-start"
                                                        transition
                                                        disablePortal
                                                        style={{ "z-index": "2" }}
                                                    >
                                                        {({ TransitionProps, placement }) => (
                                                            <Grow
                                                                {...TransitionProps}
                                                                style={{
                                                                    transformOrigin:
                                                                        placement === 'bottom-start' ? 'left top' : 'left bottom',
                                                                }}
                                                            >
                                                                <Paper sx={{ "margin-top": "5px !important" }}>
                                                                    <ClickAwayListener onClickAway={handleClose}>
                                                                        <MenuList
                                                                            autoFocusItem={open}
                                                                            id="composition-menu"
                                                                            aria-labelledby="composition-button"
                                                                            onKeyDown={handleListKeyDown}
                                                                        >

                                                                            <Box px="16px" py="6px">
                                                                                {status !== undefined && status.length > 0 ?
                                                                                    <FormGroup>
                                                                                        <FormControlLabel control={<Checkbox indeterminate={checkIndeterminateStatus()} onChange={e => changeStatus("all")} checked={checkAllStatus()} />} label={t('competency.selectAll')} />
                                                                                        {status.map((rs) => (
                                                                                            <FormControlLabel control={<Checkbox onChange={e => changeStatus(rs)} checked={checkstatus[rs]} />} label={rs} />
                                                                                        ))}
                                                                                    </FormGroup>
                                                                                    :
                                                                                    <MenuItem value="">
                                                                                        ---{t('label.notFund')}---
                                                                                    </MenuItem>
                                                                                }
                                                                            </Box>
                                                                        </MenuList>
                                                                    </ClickAwayListener>
                                                                </Paper>
                                                            </Grow>
                                                        )}
                                                    </Popper>
                                                </div>
                                            </Stack>
                                        </Box>
                                        <Box sx={{ display: "flex", flexDirection: "row", width: "180px" }} >
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="500" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "max-content", marginRight: "10px" }}>
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Divider width="100%" />
                                </Box>
                                {Util.formatData(mainItemsProgress, []).length > 0 ? mainItemsProgress.map((row, index) =>
                                (
                                    <Box px="40px">
                                        <Box sx={{ width: "100%", position: "relative", "&:before": { content: '""', position: 'absolute', height: row?.status === "inactive" ? "100%" : "0px", width: row?.status === "inactive" ? "100%" : "0px", top: "0", background: "#FAFAFA", opacity: "0.7" }, }}>
                                            <Box
                                                sx={{ height: "96px", background: "#FFF", width: "100%", display: "flex", alignItems: "center" }}
                                                px="25px"
                                            >
                                                <Box sx={{ width: "calc(36.92% - 36px)" }} pr="15px">
                                                    <Typography fontWeight="500" fontSize={18} lineHeight="26.91px" onClick={() => onOpenDetail(row?.detail, row?.status)} sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis", cursor: "pointer", "&:hover": { textDecoration: "underline", transition: "ease 300ms" } }}>
                                                        {Util.formatData(row?.name, "")}
                                                    </Typography>
                                                    <Typography fontWeight="400" fontSize={16} lineHeight="23.92px" sx={{ color: "#A3A3A3", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                        {Util.formatData(row?.template_type, "")}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ width: "calc(18.9% - 36px)" }} pr="15px">
                                                    <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                        <span style={{ color: row?.status === "complete" ? row?.detail?.import_success > row?.total ? "#EFB76D" : "#5DA196" : "#404349" }}>{row?.status !== "wait" ? Util.formatData(row?.detail?.import_success, "-") : "-"}</span> {" " + "/" + " " + Util.formatData(row?.total, "")}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ width: "calc(10.64% - 36px)" }} pr="15px">
                                                    <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: row?.fail !== 0 ? "#CC6058" : "#404349", whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                        {row?.fail === 0 ? "" : Util.formatData(row?.fail, 0)}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ width: "calc(18.9% - 36px)" }} pr="15px">
                                                    <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                        {row?.updated_by?.fullname !== undefined && row?.updated_by?.fullname !== null ? row?.updated_by?.fullname : row?.updated_at !== undefined && row?.updated_at !== null && row?.updated_at !== "" ? "Default" : ""}
                                                    </Typography>
                                                    <Typography fontWeight="400" fontSize={14} lineHeight="21px" sx={{ color: "#A3A3A3", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                        {Util.dateDayTimeFormatAdmin(row?.updated_at)}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ width: "calc(14.66% - 36px)", display: "flex", justifyContent: "center" }} pr="15px">
                                                    {row?.status === "complete" ?
                                                        <Box sx={{ background: "rgba(93, 161, 150, 0.1)", width: "100%", maxWidth: "135px", borderRadius: "5px", height: "40px", display: "flex", alignItems: "center", textAlign: "center", padding: "0 25px", }}>
                                                            <Typography fontWeight="500" fontSize={16} lineHeight="24px" sx={{ color: "#5DA196", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                Success
                                                            </Typography>
                                                        </Box>
                                                        : row?.status === "fail" ?
                                                            <Box sx={{ background: "rgba(204, 96, 88, 0.1)", width: "100%", maxWidth: "135px", borderRadius: "5px", height: "40px", display: "flex", alignItems: "center", textAlign: "center", padding: "0 25px", }}>
                                                                <Typography fontWeight="500" fontSize={16} lineHeight="24px" sx={{ color: "#CC6058", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                    Fail
                                                                </Typography>
                                                            </Box>
                                                            : row?.status === "process" ?
                                                                <Box sx={{ background: "rgba(239, 183, 109, 0.1)", width: "100%", maxWidth: "135px", borderRadius: "5px", height: "40px", display: "flex", alignItems: "center", textAlign: "center", padding: "0 25px", }}>
                                                                    <Typography fontWeight="500" fontSize={16} lineHeight="24px" sx={{ color: "#EFB76D", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                        In Progress
                                                                    </Typography>
                                                                </Box>
                                                                :
                                                                row?.status === "wait" ?
                                                                    <Box sx={{ background: "rgba(179, 183, 184, 0.1)", width: "100%", maxWidth: "135px", borderRadius: "5px", height: "40px", display: "flex", alignItems: "center", textAlign: "center", padding: "0 25px", }}>
                                                                        <Typography fontWeight="500" fontSize={16} lineHeight="24px" sx={{ color: "#B3B7B8", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                            Wait
                                                                        </Typography>
                                                                    </Box>
                                                                    :
                                                                    null
                                                    }
                                                </Box>
                                                <Box sx={{ width: "180px", display: "flex", justifyContent: "center" }}>
                                                    {row?.view_btn ?
                                                        row?.status === "wait" ?
                                                            <Button onClick={() => handleStartAgain(row?.id, row?.name, row?.template_type, row?.detail?.cycle, row?.total)} sx={{ display: "flex", height: "40px", textTransform: "none" }} variant="dashed-solid" >
                                                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                                                    <Eye style={{ cursor: "pointer" }} />
                                                                    <Typography ml="8px" fontSize={16} lineHeight="23.92px" fontWeight="500" color="#404349">View Detail</Typography>
                                                                </Box>
                                                            </Button>
                                                            :
                                                            <Button onClick={() => { openNewTab(`/admin/import/${row?.id}`) }} sx={{ display: "flex", height: "40px", textTransform: "none" }} variant="dashed-solid" >
                                                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                                                    <Eye style={{ cursor: "pointer" }} />
                                                                    <Typography ml="8px" fontSize={16} lineHeight="23.92px" fontWeight="500" color="#404349">View Detail</Typography>
                                                                </Box>
                                                            </Button>
                                                        :
                                                        null
                                                    }
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Divider width="100%" />
                                    </Box>
                                ))
                                    :
                                    <Box sx={{ paddingTop: "87px", textAlign: "center", paddingBottom: "143px" }}>
                                        <Nodata />
                                        <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                            No data found
                                        </Typography>
                                    </Box>
                                }
                            </Paper>
                        </div>
                    </Box>
                    <Grid container mt={1} spacing={2} >
                        <Grid item xs sm md display="flex" alignItems="center">
                            <Box mr={1}>
                                <Typography variant="s14_fw400">{t('label.showMaxItems')}</Typography>
                            </Box>
                            <Select
                                id="pagination"
                                variant="outlined"
                                defaultValue={10}
                                value={perPage}
                                onChange={handlePerPageChange}
                                displayEmpty
                                size="small"
                                className="white-bg"
                            >
                                <MenuItem value={10}>
                                    <Typography style={{ fontWeight: "300" }}>10</Typography>
                                </MenuItem>
                                <MenuItem value={20}>
                                    <Typography style={{ fontWeight: "300" }}>20</Typography>
                                </MenuItem>
                                <MenuItem value={30}>
                                    <Typography style={{ fontWeight: "300" }}>30</Typography>
                                </MenuItem>
                            </Select>
                        </Grid>
                        <Grid item display="flex" alignItems="center" ml="auto">
                            <Typography variant="s14_fw400">
                                {t('label.page')} {currentPage} {t('label.of')} {totalPage}
                            </Typography>
                        </Grid>
                        <Grid item ml="auto" display="flex" alignItems="center">
                            <CustomPagination
                                setCurrentPage={handleSetCurrentPage}
                                selected={currentPage}
                                count={totalPage}
                            ></CustomPagination>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <DialogDownloadTemplate open={openDownloadTemplate} close={onCloseDownloadTemplate} typeFiles={typeFiles} />
            <DialogDetail data={dataDetail} status={statusDetail} open={openDetail} close={onCloseDetail} />
            <ConfirmDialog open={confirmSendDialog} warning={true} doConfirm={() => handleSendConfirm()} setValue={() => startAgain ? handleCancelConfirm() : handleConfirmSendDialog(false)} setValueClose={() => handleConfirmSendDialog(false)}
                title="Confirmation of import file"
                text={"Are you sure to import file?"}
                fileName={Util.formatData(fileName, "-")}
                type={Util.formatData(templateTypeName, "-")}
                cycle={Util.formatData(cycleName, "-")}
                total={Util.formatData(totalRow, 0)}
            />
            <MessageDialog
                open={openFailedMessageDialog}
                setValue={handleCloseFailedMessageDialog}
                type="warning"
                title={"Import unsuccessfully"}
                text={"The file could not be imported</br>please revise data and try again."}
                twoText={true}
                goResult={handleGoToResult}
                page="import"
            />
        </Box>
    );
};
export default Import;
